import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungBremerhaven() {
  return (
    <CityPageTemplate
      city="Bremerhaven"
      slug="bremerhaven"
      intro="In der Hafenstadt Bremerhaven beraten wir Dich digital und unabhängig – ganz ohne Banktermin."
      description="Unabhängige & digitale Finanzberatung für Bremerhaven: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
